<template>
  <div>
    <div class="add-document" v-if="!userRoles.canSysAdminAccess && !userRoles.canStudyAdminAccess && !userRoles.canSiteDataLockAccess && !userRoles.canStudyManagerAccess && !user.readOnly && !userRoles.canCraAccess && !userRoles.canCraUBAccess">
      <div class="plus-sign pull-left" @click="openUploadModal()">
        <span class="plus">+</span>
      </div>
      <div class="pull-left cursor_pointer" @click="openUploadModal()">
        Add a source document
      </div>
      <div class="pull-left max-size">Max file size: 100mb</div>
      <div style="clear:both;"></div>
    </div>
    <b-modal ref="upload-modal" hide-footer hide-header>
      <div class="d-block text-center upload-modal">
        <div class="description">
          Documents uploaded to this secure platform, including any containing PII, will be visible to all CRA roles associated with this study.
        </div>
        <div class="btnbindCSS">
          <div class="btn-grp mt-30">
            <div class="file-upload understand-button"><input type="file" id="myfile" name="myfile" class="file-input" @change="selectedFile()" @click="closeUploadModal()" />I understand</div>
          </div>
          <div class="btn-grp mt-30">
            <div class="file-upload btn-cancelcss" @click="closeUploadModal()">
              Cancel
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal ref="progress-modal" hide-footer hide-header>
      <div class="d-block text-center progress-modal">
        <div class="upload-file">Uploading file...</div>
        <img src="static/img/icn-csv.png" />
        <div class="pb-15">{{ fileName }}</div>
        <progress id="progressBar" value="0" max="100" class="progress"></progress>
        <div class="uploading-now">
          Uploading now. Thanks for being patient.
        </div>
        <div class="uploading-now delete pt-40">
          <span class="cursor_pointer" @click="cancelUpload()">Cancel upload</span>
        </div>
      </div>
    </b-modal>
    <table-component v-if="documentlist" showEmpty noGutters :items="documentlist" :fields="formHistoryFields">
      <template slot="doc_name" slot-scope="data">
        {{ data.row.item.doc_name }}
      </template>
      <template slot="created_time" slot-scope="data">{{ new Date(data.row.item.created_time) | formatGMTDate }}</template>
      <template slot="uploadedBy" slot-scope="data"
        >{{ data.row.item.created_by }}
        <span v-if="data.row.item.issuer_role === 'Cra'">(CRA(B))</span>
        <span v-else-if="data.row.item.issuer_role === 'CraUB'">(CRA(U))</span>
        <span v-else>({{ data.row.item.issuer_role | uppercase }})</span>
      </template>
      <template slot="fileSize" slot-scope="data">{{ data.row.item.file_size }}</template>
      <template slot="Download" slot-scope="data" v-if="!userRoles.canSysAdminAccess && !userRoles.canStudyAdminAccess && !userRoles.canSiteDataLockAccess && !userRoles.canStudyManagerAccess && !userRoles.canCraAccess">
        <a @click="downloadDocument(data.row.item.preSignedUrl)" class="download cursor_pointer">Download</a>
      </template>
      <template slot="Delete" slot-scope="data" v-if="!userRoles.canSysAdminAccess && !userRoles.canStudyAdminAccess && !userRoles.canSiteDataLockAccess && !userRoles.canStudyManagerAccess && !user.readOnly && !userRoles.canCraAccess && !userRoles.canCraUBAccess">
        <a @click="deleteDocument(data.row.item.id)" class="delete cursor_pointer">Delete</a>
      </template>
    </table-component>
    <div id="docResponseModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header border-none p-0">
            <button type="button" class="btnclose close close pr-25" data-dismiss="modal">
              <span class="closeText">CLOSE</span>&nbsp;
              <span class="closeIcon">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <iframe class="iframeLayout" :src="ViewUrl" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/common/table";
import swal from "sweetalert2";

export default {
  name: "participant-activity-response-source-documents",
  components: {
    TableComponent
  },
  props: ["_documentlist", "surveyId", "revisionId", "surveyResponseTrackerId", "userRoles", "participantId"],
  data() {
    return {
      xmlHTTP: "",
      uploadUrl: "",
      uuid: "",
      fileName: "",
      filesize: "",
      formHistoryFields: [
        {
          key: "doc_name",
          label: "NAME",
          sortable: true
        },
        {
          key: "created_time",
          label: "UPLOADED",
          sortable: true
        },
        {
          key: "uploadedBy",
          label: "BY",
          sortable: false
        },
        {
          key: "fileSize",
          label: "FILE SIZE",
          sortable: false
        },
        {
          key: "Download",
          label: "ACTIONS"
        },
        {
          key: "Delete",
          label: " "
        }
      ],
      ViewUrl: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters["user"];
    },
    documentlist() {
      if (!this._documentlist) {
        return [];
      }
      if (this._documentlist && this._documentlist.length) {
        return this._documentlist.filter(document => document.status != 1);
      }
      return [];
    }
  },
  methods: {
    getSourceDocuments() {
      this.$emit("getDocumentsList");
    },
    openUploadModal() {
      this.$refs["upload-modal"].show();
    },
    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) {
        return "0 Byte";
      }
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    selectedFile() {
      this.$api.getDocumentPreSignedUrlFact(this.revisionId, this.participantId).then(
        response => {
          this.uploadUrl = response.body.data.url;
          this.uuid = response.body.data.uuid;
          document.getElementById("progressBar").value = 0;
          const selectedFile = document.getElementById("myfile");
          const file = selectedFile.files[0];
          if (file) {
            if (file.size < 104857600) {
              this.$refs["progress-modal"].show();
              const url = this.uploadUrl;
              this.fileName = file.name;
              this.filesize = this.bytesToSize(file.size);
              this.$forceUpdate();
              this.xmlHTTP = new XMLHttpRequest();
              this.xmlHTTP.upload.addEventListener("progress", this.progressFunction, false);
              this.xmlHTTP.addEventListener("load", this.transferCompleteFunction, false);
              this.xmlHTTP.addEventListener("error", this.uploadFailed, false);
              this.xmlHTTP.addEventListener("abort", this.uploadCanceled, false);
              this.xmlHTTP.open("PUT", url, true);
              this.xmlHTTP.setRequestHeader("Content-Type", file.type);
              this.xmlHTTP.send(file);
            } else {
              this.$toastr.error("File size exceeds the maximum of 100 MB.");
              document.getElementById("myfile").value = null;
            }
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading the document.");
        }
      );
    },
    progressFunction(evt) {
      const progressBar = document.getElementById("progressBar");
      if (evt.lengthComputable) {
        progressBar.max = evt.total;
        progressBar.value = evt.loaded;
      }
    },
    transferCompleteFunction() {
      const data = {
        s3_doc_path: this.uuid,
        doc_name: this.fileName,
        created_by: this.user.firstName + " " + this.user.lastName,
        status: "0",
        file_size: this.filesize,
        tracker_id: this.surveyResponseTrackerId,
        issuerRole: this.user.userRole
      };
      this.$api.postNewSurveyResponseSourceDocument(this.surveyId, this.revisionId, this.participantId, data).then(
        () => {
          this.getSourceDocuments();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading the document.");
        }
      );
      this.$refs["progress-modal"].hide();
      document.getElementById("myfile").value = null;
    },
    uploadFailed() {
      this.$toastr.error("Error while uploading the document.");
    },
    downloadDocument(preSignedUrl) {
      window.open(preSignedUrl, "_blank");
    },
    deleteDocument(documentId) {
      swal({
        title: "Are you sure you want to delete the document?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .deleteSurveyResponseSourceDocument(this.surveyId, this.revisionId, documentId, {
              documentId,
              modifiedBy: this.user.firstName + " " + this.user.lastName
            })
            .then(
              () => {
                this.getSourceDocuments();
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting the document.");
              }
            );
        }
      });
    },
    cancelUpload() {
      this.xmlHTTP.abort();
      this.$refs["progress-modal"].hide();
      document.getElementById("myfile").value = null;
    },
    closeUploadModal() {
      this.$refs["upload-modal"].hide();
    },
    showFilePreviewModal(data) {
      window.$("#docResponseModal").modal();
      this.ViewUrl = data.preSignedUrl;
    }
  }
};
</script>
<style lang="scss" scoped>
.add-document {
  padding: 20px;
  color: #4c8ce4;
  font-weight: bold;
}

.progress {
  width: 400px;
  margin: 0 auto;
  height: 5px !important;
}

.download {
  color: #4c8ce4 !important;
}

.delete {
  color: #f16559 !important;
}

.upload-modal {
  padding: 40px;
  font-weight: bold;
}

.understand-button {
  background-color: #4c8ce4 !important;
  padding: 10px 50px;
  margin: 14px;
  color: #ffffff !important;
  border-radius: 100px;
  font-weight: normal !important;
}

.plus-sign {
  width: 17px;
  height: 17px;
  border-radius: 100px;
  background-color: #4c8ce4;
  color: #ffffff;
  text-align: center;
  margin-right: 5px;
  position: relative;
  top: 2px;
  cursor: pointer;
}

.plus {
  position: relative;
  bottom: 1.5px;
}

.progress-modal {
  padding: 20px;
}

.upload-file {
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 30px;
}

.uploading-now {
  font-size: 12px;
  padding-top: 10px;
  color: #666669;
}

progress::-webkit-progress-value {
  background: #4c8ce4 !important;
}

.max-size {
  color: grey;
  font-size: 12px;
  font-weight: normal;
  margin: 3px 0 0 10px;
}
.quick-view-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: #dcdcdc;
  border-radius: 5px;
}
.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #dcdcdc;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  width: 1296px;
  right: 330px;
  height: auto;
}
.btnclose {
  position: relative;
  bottom: 30px;
  opacity: 1;
}
.closeText {
  color: #ffffff;
  font-size: 12px;
  font-weight: 200;
}
.closeIcon {
  color: #ffffff;
  font-size: 20px;
  position: relative;
  top: 2.5px;
  right: 7px;
  font-weight: 200;
}
.iframeLayout {
  width: 1285px;
  height: auto;
  position: relative;
  bottom: 35px;
  right: 12px;
}
.modal-body {
  padding: 1rem 1rem 0rem 1rem;
  margin-bottom: -28px;
}
.btn-cancelcss {
  background-color: rgb(241, 101, 89);
  padding: 10px 50px;
  margin: 14px;
  color: #fff !important;
  border-radius: 100px;
  font-weight: normal !important;
}
.btnbindCSS {
  display: flex;
}
.wrngCSS {
  text-align: center;
  font-size: x-large;
  font-weight: bold;
}
</style>
